export default {
  TOWERS: 'towers',
  LEVELS: 'levels',
  UNITS: 'units',
  POINTS_OF_INTEREST: 'pointsOfInterest',
  NEIGHBOURHOOD_SUBDIVISIONS: 'neighbourhoodSections',
}
